import React from 'react';

import RegistryBlockModalBridge from 'components/Layout/RegistryBlockModalBridge';
import { useRegistryCheckModal } from 'v2/hooks/useRegistryCheckModal';

import OriginalRegistryBlockModal from '@myeduzz-vertical/root/RegistryBlockModal';

export default function RegistryBlockModal(props: MyEduzzRegistryBlockModalProps) {
  const { opened, isOwner } = props;

  useRegistryCheckModal(opened && isOwner);

  return (
    <RegistryBlockModalBridge>
      <OriginalRegistryBlockModal {...props} />
    </RegistryBlockModalBridge>
  );
}
